import React from "react";
import { useLocation } from "react-router-dom";
import TopNav, { BottomNav } from "./TopNav";
import Footer from "./Footer";
import PaywallModal from "@/components/billing/PaywallModal";

export default function AppShell({ children }) {
  const { pathname } = useLocation();
  const hideFooter = pathname.startsWith("/messages");
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F4EF]">
      <TopNav />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      {!hideFooter && <Footer />}
      <BottomNav />
      <PaywallModal />
    </div>
  );
}
